<template>
  <div class="tabs" :style="{position:sticky&&'sticky',top:top}">
    <div
      v-for="(item, index) in data"
      :key="index"
      :class="[activeIndex === item.value ? 'tabs-sub-active' : 'tabs-sub',]"
      :style="{color:activeIndex === item.value ? activeColor : ''}"
      @click="handleClick(item.value)"
    >
      <div>{{ item.label }}</div>
      <div
        v-show="activeIndex === item.value"
        class="line"
        :style="{background:activeIndex === item.value ? activeColor : ''}"
      ></div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'NxTabs',
  model: {
    prop: 'curernt',
    event: 'change',
  },
  props: {
    curernt: {
      type: [Number, String],
      default: 0,
    },
    sticky: {
      type: Boolean,
    },
    activeColor: {
      type: String,
      default: '',
    },
    top: {
      type: [Number, String],
      default: 0,
    },

    data: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      activeIndex: '',
    };
  },
  watch: {
    curernt: {
      handler(n, o) {
        this.activeIndex = n;
      },
      immediate: true,
    },
  },
  methods: {
    handleClick(value) {
      this.activeIndex = value;
      this.$emit('change', value);
    },
  },
};
</script>

<style lang="scss" scoped>
.tabs {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 18px;
  height: 44px;
  background: #fff;
  z-index: 999;

  // overflow: scroll;
  .tabs-sub {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-size: 16px;
    height: 100%;
    line-height: 100%;
    font-weight: 300;
    color: #7A8499;
    cursor: pointer;

    &-active {
      @extend .tabs-sub;
      color: #141E34;
      font-weight: 500;
      font-size: 17px;
      line-height: 100%;
    }
  }

}
.line{
  position: absolute;
  width: 12px;
  height: 2px;
  bottom: 0;
  right: 50%;
  transform: translateX(50%);
  background: #141E34;
  border-radius: 2px;
}

</style>
